import { create } from 'zustand';
import dayjs from 'dayjs';

interface LimitedActivityStore {
  isNewUserOnly: boolean;
  limitedTimeActivityDateRange?: {
    start: string;
    end: string;
  };
  // 已订购用户持续月数
  durationInMonths: number;
  initData: (params: { dateRange?: { start: string; end: string }; isNewUserOnly?: boolean }) => void;
  updateDurationInMonths: (params: {
    activityStartTime?: string;
    activityEndTime?: string;
    isNewUserOnly: boolean;
    packageOrderTime?: string;
    isSubscriber?: boolean;
  }) => void;
}

export const useLimitedActivityStore = create<LimitedActivityStore>((set) => ({
  isNewUserOnly: true,
  limitedTimeActivityDateRange: undefined,
  durationInMonths: 0,
  initData: (params) =>
    set({
      limitedTimeActivityDateRange: params.dateRange,
      isNewUserOnly: !!params.isNewUserOnly,
    }),
  updateDurationInMonths: (params) => {
    const { activityStartTime, activityEndTime, isNewUserOnly, packageOrderTime, isSubscriber } = params;

    // 如果不是订购用户，或者活动开始时间或订购时间无效，则持续月数为0
    if (!isSubscriber || !activityStartTime || !activityEndTime || !packageOrderTime) {
      set({ durationInMonths: 0 });
      return;
    }

    const orderDate = dayjs(packageOrderTime);
    const startDate = dayjs(activityStartTime).startOf('day');
    const endDate = dayjs(activityEndTime).endOf('day');
    const currentDate = dayjs();

    if (!startDate.isValid() || !endDate.isValid() || !orderDate.isValid()) {
      set({ durationInMonths: 0 });
      return;
    }

    // 计算两个日期之间的月份差（订购当月算第1个月）
    const calculateMonthsDiff = (fromDate: dayjs.Dayjs, toDate: dayjs.Dayjs = currentDate) => {
      const fromMonth = fromDate.startOf('month');
      const toMonth = toDate.startOf('month');
      return toMonth.diff(fromMonth, 'month') + 1;
    };

    // 检查订购时间是否在活动时间范围内
    const isOrderInActivityRange = !(orderDate.isBefore(startDate) || orderDate.isAfter(endDate));

    if (isNewUserOnly) {
      // 新用户限制活动：只有在活动期间订购才计算月数
      if (!isOrderInActivityRange) {
        set({ durationInMonths: 0 });
        return;
      }
      set({ durationInMonths: calculateMonthsDiff(orderDate) });
      return;
    }

    // 非新用户限制活动
    if (orderDate.isAfter(endDate)) {
      // 订购时间晚于活动结束时间
      set({ durationInMonths: 0 });
      return;
    }
    // 订购时间在活动范围内，从订购时间计算
    set({ durationInMonths: calculateMonthsDiff(orderDate) });
  },
}));
